import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import IconAlert from './IconAlert';
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error)
  }

  render() {
    const { hasError } = this.state;
    const { component } = this.props;

    if (hasError) {
      return <>
        {component === undefined && <div {...this.props}><IconAlert icon={faExclamationTriangle} color="danger"><strong>Something went wrong!</strong></IconAlert></div>}
        {component !== undefined && <>{component}</>}
      </>

    }

    return this.props.children;
  }
}
export default ErrorBoundary